import axios, { type InternalAxiosRequestConfig, type AxiosResponse, type AxiosError } from 'axios';
import { clearAuthSession, tokenStorage } from '@/features/auth/auth-session';
import { getSignInUrl, SIGN_IN_PATH } from '@/features/auth/return-url';

const httpClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
httpClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = tokenStorage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
httpClient.interceptors.response.use(
  (response: AxiosResponse) => {
    if (
      response.config.headers['X-Ignore-Response-Validation'] !== 'true' &&
      response.data &&
      !response.data.success &&
      response.data.message
    ) {
      return Promise.reject({ response });
    }
    return response;
  },
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      clearAuthSession();

      if (window.location.pathname !== SIGN_IN_PATH) {
        window.location.replace(getSignInUrl());
      }
    }
    return Promise.reject(error);
  }
);

export default httpClient;
